import createVueComponent from '../createVueComponent';

const ShieldAlert = createVueComponent('ShieldAlertIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10', key: '1irkt0' }],
  ['path', { d: 'M12 8v4', key: '1got3b' }],
  ['path', { d: 'M12 16h.01', key: '1drbdi' }],
]);

export default ShieldAlert;
